export default __webpack_public_path__ + "static/media/pointImg.b643e702.png";